import * as actionTypes from './actionTypes';

export const hideMobileHome = () => {
    return {
        type: actionTypes.HIDE_MOBILE_HOME
    }
}

export const showMobileHome = () => {
    return {
        type: actionTypes.SHOW_MOBILE_HOME
    }
}

export const toggleFareBreakups = (value) => {
    return {
        type: actionTypes.TOGGLE_FARE_BREAKUPS,
        val: value
    }
}

export const toggleMobileFilters = () => {
    return {
        type: actionTypes.TOGGLE_MOBILE_FILTERS
    }
}

export const toggleMobileFareBreakup = () => {
    return {
        type: actionTypes.TOGGLE_MOBILE_FARE_BREAKUP
    }
}

export const toggleMobileReviews = () => {
    return {
        type: actionTypes.TOGGLE_MOBILE_REVIEWS
    }
}

export const showMobileBookingEngine = () => {
    return {
        type: actionTypes.SHOW_MOBILE_BOOKING_ENGINE
    }
}

export const hideMobileBookingEngine = () => {
    return {
        type: actionTypes.HIDE_MOBILE_BOOKING_ENGINE
    }
}

export const toggleMobileBookingEngine = () => {
    return {
        type: actionTypes.TOGGLE_MOBILE_BOOKING_ENGINE
    }
}

export const toggleTabletBookingEngine = () => {
    return {
        type: actionTypes.TOGGLE_TABLET_BOOKING_ENGINE
    }
}

export const showTabletBookingEngine = () => {
    return {
        type: actionTypes.SHOW_TABLET_BOOKING_ENGINE
    }
}

export const hideTabletBookingEngine = () => {
    return {
        type: actionTypes.HIDE_TABLET_BOOKING_ENGINE
    }
}

export const showMobileCloseBookingEngineButton = () => {
    return {
        type: actionTypes.SHOW_MOBILE_CLOSE_BOOKING_ENGINE_BUTTON
    }
}

export const toggleInsurance = () => {
    return {
        type: actionTypes.TOGGLE_INSURANCE
    }
}

export const toggleGst = () => {
    return {
        type: actionTypes.TOGGLE_GST
    }
}

export const toggleAddons = (view) => {
    return {
        type: actionTypes.TOGGLE_ADDONS,
        val: view
    }
}


export const switchHeaderView = (view) => {
    return {
        type: actionTypes.SWITCH_HEADER_VIEW,
        val: view
    }
}

export const toggleFullCalendar = () => {
    return {
        type: actionTypes.TOGGLE_FULL_CALENDAR
    }
}

export const closeFullCalendar = () => {
    return {
        type: actionTypes.CLOSE_FULL_CALENDAR
    }
}

export const toggleRtDepart = () => {
    return {
        type: actionTypes.TOGGLE_RT_DEPART
    }
}

export const toggleRtReturn = () => {
    return {
        type: actionTypes.TOGGLE_RT_RETURN
    }
}

export const closeRtDepart = () => {
    return {
        type: actionTypes.CLOSE_RT_DEPART
    }
}

export const closeRtReturn = () => {
    return {
        type: actionTypes.CLOSE_RT_RETURN
    }
}

export const openDropDown = (id) => {
    return {
        type: actionTypes.OPEN_DROPDOWN,
        id: id
    }
}

export const closeDropDown = () => {
    return {
        type: actionTypes.CLOSE_DROPDOWN
    }
}

export const userImageUpload = (file, url, id) => {
    return {
        type: actionTypes.USER_IMAGE_UPLOAD,
        file: file,
        url: url,
        id: id
    }
}

export const togglePaymenMethod = () => {
    return {
        type: actionTypes.TOGGLE_PAYMENT_METHOD
    }
}

export const setPaymentMode = (mode) => {
    return {
        type: actionTypes.SET_PAYMENT_MODE,
        val: mode
    }
}


export const setBankOptions = (option, code) => {
    return {
        type: actionTypes.SET_BANK_OPTION,
        val: option,
        code: code
    }
}

export const setWalletOptions = (option) => {
    return {
        type: actionTypes.SET_WALLET_OPTION,
        val: option
    }
}

export const toggleMobileFlightDetail = () => {
    return {
        type: actionTypes.TOGGLE_MOBILE_FLIGHT_DETAIL
    }
}

export const addonsExpanded = () => {
    return {
        type: actionTypes.ADDONS_EXPANDED
    }
}

export const resetAddons = () => {
    return {
        type: actionTypes.RESET_ADDONS
    }
} 

export const setSlideLeft = () => {
    return {
        type: actionTypes.SET_SLIDE_LEFT
    }
}

export const setSlideRight = () => {
    return {
        type: actionTypes.SET_SLIDE_RIGHT
    }
}

export const resetSlideCounter = () => {
    return {
        type: actionTypes.RESET_SLIDE_COUNTER
    }
}

export const closeDesktopFilters = () => {
    return {
        type: actionTypes.CLOSE_DESKTOP_FILTERS
    }
}

export const toggleDesktopFilters = () => {
    return {
        type: actionTypes.TOGGLE_DESKTOP_FILTERS
    }
}

export const hideFareAlert = () => {
    return {
        type: actionTypes.HIDE_FARE_ALERT
    }
}

export const toggleAgentProfit = () => {
    return {
        type: actionTypes.TOGGLE_AGENT_PROFIT
    }
}

export const toggleRoundTripFareRules = () => {
    return {
        type: actionTypes.TOGGLE_ROUND_TRIP_FARE_RULES
    }
}

export const closeRoundTripFareRules = () => {
    return {
        type: actionTypes.CLOSE_ROUND_TRIP_FARE_RULES
    }
}

export const toggleRecentBookingType = (val) => {
    return {
        type: actionTypes.TOGGLE_RECENT_BOOKING_TYPE,
        val: val
    }
}

export const togglePaymentOptionsMobile = (val) => {
    return {
        type: actionTypes.TOGGLE_PAYMENT_OPTIONS_MOBILE,
        val: val
    }
}

export const closeGst = () => {
    return {
        type: actionTypes.CLOSE_GST
    }
}

export const toggleDetailsView = (view) => {
    return {
        type: actionTypes.TOGGLE_DETAILS_VIEW,
        view: view
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/ui.js